import {atom} from 'recoil'

export const stateInputHex5 = atom({
    key: "inputHex5",
    default: ''
})
